import { FiCheckCircle, FiClock, FiXCircle } from "react-icons/fi";
import { Badge, Text } from "rizzui";
import { EXeroPaymentStatus } from "@/utilities/types/Payment";
type StatusColor = "success" | "warning" | "danger";

interface PaymentStatusProps {
  status: EXeroPaymentStatus;
}

export default function PaymentStatus({ status }: PaymentStatusProps) {
  const getStatusConfig = () => {
    switch (status) {
      case EXeroPaymentStatus.SUCCEED:
        return {
          color: "success" as StatusColor,
          icon: <FiCheckCircle className="h-5 w-5" />,
          text: "Payment Completed",
          description: "Your payment has been successfully processed.",
        };
      case EXeroPaymentStatus.FAILED:
        return {
          color: "danger" as StatusColor,
          icon: <FiXCircle className="h-5 w-5" />,
          text: "Payment Failed",
          description:
            "There was an issue processing your payment. Please try again.",
        };
      case EXeroPaymentStatus.PENDING:
      default:
        return {
          color: "warning" as StatusColor,
          icon: <FiClock className="h-5 w-5" />,
          text: "Payment Pending",
          description:
            "Your payment is being processed. This may take a few minutes.",
        };
    }
  };

  const { color, icon, text, description } = getStatusConfig();

  return (
    <div className="rounded-lg border border-gray-100 p-4">
      <div className="mb-4 flex items-center justify-between">
        <Text className="text-base font-medium text-gray-900">
          Payment Status
        </Text>
        <Badge
          variant="flat"
          color={color}
          className="flex items-center gap-1.5 px-2.5 py-1"
        >
          {icon}
          {text}
        </Badge>
      </div>
      <Text className="text-sm text-gray-500">{description}</Text>
    </div>
  );
}
